import { useGenericModal } from '..';

import { EditChannelNameModal } from './edit-channel-name-modal';

export const useEditChannelNameModal = ({
  currentName,
  onSave,
}: {
  currentName: string;
  onSave: (name: string) => void;
}) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const editChannelNameModal = (
    <EditChannelNameModal
      modalRef={modalRef}
      currentName={currentName}
      onSave={onSave}
      onClose={closeModal}
    />
  );

  return { openModal, closeModal, editChannelNameModal };
};
